import { resetToInitialLanguage } from '../../../../utils/language';
import { setViewType } from '../../../../store/authslice';
import { checkIfModelRequired, clearPOISelection, setDirections, setDirectionsPanel, setOpenRoomDetailsWithQR, setResetWidgets, setRoomDetailsPopUp, setRoomFinderOpen, setRoomSearchPopUp, setShowQRFrame, } from '../../../../store/uislice';
import { setSelectedLocation } from '../../redux/spaces-slice';
import { invokeRichMapMethod } from '../components/map/rich-map';
/** Shared cleanup for inactivity reset and a floor becoming inaccessible. */
export const resetWorkspaceView = (dispatch, { floorId, resetWhereAmI = false, } = {}) => {
    void resetToInitialLanguage().catch((error) => {
        console.error('Failed to restore the initial screen language:', error);
    });
    dispatch(setDirectionsPanel({ payload: null }));
    dispatch(setDirections({ payload: null }));
    dispatch(setRoomDetailsPopUp({ payload: null }));
    dispatch(setRoomFinderOpen({ payload: false }));
    dispatch(setRoomSearchPopUp({ payload: false }));
    dispatch(setOpenRoomDetailsWithQR({ payload: false }));
    dispatch(setShowQRFrame({ payload: true }));
    dispatch(clearPOISelection());
    if (!resetWhereAmI || !invokeRichMapMethod('prevNavigationLevel')) {
        invokeRichMapMethod('exitNavigation');
    }
    if (floorId != null) {
        dispatch(setSelectedLocation(floorId));
        if (floorId === '')
            dispatch(setViewType('building'));
    }
    invokeRichMapMethod('reset');
    if (resetWhereAmI) {
        setTimeout(() => {
            dispatch(checkIfModelRequired());
            invokeRichMapMethod('reset');
        }, 1000);
    }
    else {
        dispatch(checkIfModelRequired());
    }
    dispatch(setResetWidgets({ payload: Date.now() }));
};
